import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-bookmarks-subject-dialog',
  templateUrl: './bookmarks-subject-dialog.component.html',
  styleUrls: ['./bookmarks-subject-dialog.component.css']
})
export class BookmarksSubjectDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<BookmarksSubjectDialogComponent>) { }
  selctedSubjects:any =[]

  ngOnInit(): void {

     this.selctedSubjects =this.data.selectedSubjects
 
  }
   cancel(){
    this.dialogRef.close(true);
   }
  close() {
    this.dialogRef.close(this.selctedSubjects);
  }
  onSubjectChange(event:any,item:any){
   console.log(event.target.checked)
   if(event.target.checked){
    this.selctedSubjects.push(item.nodeId);
   }else{
    this.selctedSubjects = this.selctedSubjects.filter((item1:any)=> item.nodeId != item1);
    if(this.selctedSubjects.length ==0){
      this.selctedSubjects= [];
    }
   }

  }

  isSelected(item:any){
    let subjectId:any = this.data.selectedSubjects.find((itemId:any)=> itemId==item);
    if(subjectId){
      return true;
    }else{
      return false;
    }
  }

  
}
